import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { computeSafeSpawnPosition } from './spawnHelper';

/**
 * Aduka SS (GunBound Super Shot - Thor's Hammer): a single phase shell that
 * passes through BOTH terrain and tanks. It never collides or explodes - it
 * flies straight through everything on a ballistic arc, dealing a solid
 * one-time burst (`WA_PHYSICS.ADUKA_SS.DAMAGE_PER_TANK`) to every enemy tank it
 * passes through, then sails off the map. (Phases through terrain like Nak and
 * through worms like Grub SS, but a burst-per-tank rather than DoT.)
 */
export const WeaponAdukaSS: WeaponDefinition = {
  id: 'adukaSS',
  name: 'Aduka SS',
  icon: 'adukaSS.png',
  category: 'thrown',
  maxAmmo: 1,
  maxUsesPerTurn: 1,
  powerCharging: true,
  timerAdjustable: false,
  showAimGuide: true,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm, angle, power, world } = ctx;

    const speed = (power / 100) * 750;
    const rad = (angle * Math.PI) / 180;
    const aimRad = worm.facing === 'right' ? rad : Math.PI - rad;
    const spawn = computeSafeSpawnPosition(worm, aimRad, 20, world);

    const shell = new Projectile({
      x: spawn.x,
      y: spawn.y,
      vx: Math.cos(aimRad) * speed,
      vy: -Math.sin(aimRad) * speed,
      type: 'adukaSS',
      timer: -1,
      windAffected: true,
      phaseTerrain: true, // flies straight through terrain
      ownerId: worm.id,
    });

    return { success: true, entities: [shell] };
  },
};
